import { type SessionEndReason, UserProvider } from "@platform/user/client";
import { type ReactNode, useCallback } from "react";
import { useNavigate } from "react-router";

import { type SignIn, signIn } from "./signIn";

import type { SessionConfig } from "@platform/user/client";

// The local session never reaches Auth0, so any tenant serves its unused SSO config.
const FALLBACK_SSO_TENANT = {
  domain: "centro-bp-qat.us.auth0.com",
  clientId: "zi2AJR2Lh2DLA6PGhhBluprEhX9Tnhu1",
};

const sessionConfigFor = (current: SignIn): SessionConfig => {
  const tenant =
    current.kind === "auth0" ? current.tenant : FALLBACK_SSO_TENANT;
  return {
    // Only password sessions refresh through it, and the golden UI has none that do.
    apiBaseUrl: "/api/",
    sso: { ...tenant, audience: tenant.clientId },
  };
};

/** The user lib's session; when a session ends, back to the sign-in page. */
export const SessionProvider = ({
  children,
}: {
  readonly children: ReactNode;
}): ReactNode => {
  const navigate = useNavigate();
  const onSessionEnd = useCallback(
    (_reason: SessionEndReason) => {
      void navigate("/");
    },
    [navigate],
  );

  return (
    <UserProvider config={sessionConfigFor(signIn)} onSessionEnd={onSessionEnd}>
      {children}
    </UserProvider>
  );
};
